import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SIGN_IN_TYPES } from 'pages/entry/entry.helpers';
import { Observable } from 'rxjs';
import { ExternalLoginSettings } from 'interfaces/external-login.interface';
import { map } from 'rxjs/operators';

@Component({
  selector: 'cm-external-login-icons',
  templateUrl: 'external-services-icons.component.html',
  styleUrls: ['external-services-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalServicesIconsComponent implements OnInit {
  @Input() signInType: SIGN_IN_TYPES;
  @Input() settings$: Observable<ExternalLoginSettings>;

  readonly SIGN_IN_TYPES = SIGN_IN_TYPES;
  signInLabel$: Observable<string>;

  ngOnInit() {
    this.signInLabel$ = this.settings$.pipe(
      map(settings => {
        if (!this.signInType) {
          return '';
        }
        return settings[this.signInType] ? settings[this.signInType].loginProviderName : '';
      }),
    );
  }
}
